module.exports = __webpack_public_path__ + "img/64.a5f0a1d7.png";